var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"status-press-card"}},[_c('h5',[_vm._v("Prensa")]),_c('div',{staticClass:"card"},[_c('StartupPress',{attrs:{"documents":_vm.documents}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }